import { investorApi } from '@core/api/httpClient'
import { get } from '@shared/adapters/lodash'
import { FIAT_WALLET_ENDPOINTS } from './fiatWalletEndpointPaths'
import { parseAddFunds, parseFiatWallet, parseSlicealAccount } from './fiatWalletParser'
import type {
  AddFundsInput,
  AddFundsResult,
  FiatWallet,
  SlicealAccount,
  WithdrawalInput,
  WithdrawalResult,
} from '../types/fiatWalletTypes'

export async function getFiatWallet(): Promise<FiatWallet> {
  const { data } = await investorApi.get<unknown>(FIAT_WALLET_ENDPOINTS.FIAT_WALLET)
  return parseFiatWallet(data)
}

export async function getSlicealAccount(): Promise<SlicealAccount> {
  const { data } = await investorApi.get<unknown>(FIAT_WALLET_ENDPOINTS.DEPOSIT_ACCOUNT)
  return parseSlicealAccount(data)
}

export async function submitWithdrawal(input: WithdrawalInput): Promise<WithdrawalResult> {
  // Investor explicitly picks the destination bank account; the backend
  // requires `bankAccountId` and validates it is verified + owned by the
  // current investor (see InitiateWithdrawalRequestDto).
  const { data } = await investorApi.post<unknown>(FIAT_WALLET_ENDPOINTS.FIAT_WALLET_WITHDRAWAL, {
    amount: input.amount,
    idempotencyKey: input.idempotencyKey,
    bankAccountId: input.bankAccountId,
  })
  const body = get(data, 'data') ?? {}
  return {
    id: get(body, 'id'),
    status: get(body, 'status'),
    amount: get(body, 'amount'),
    currencyCode: get(body, 'currencyCode') ?? get(body, 'currency_code'),
    createdAt: get(body, 'createdAt') ?? get(body, 'created_at'),
  }
}

export async function addFunds(input: AddFundsInput): Promise<AddFundsResult> {
  const formData = new FormData()
  formData.append('amount', input.amount.toString())
  formData.append('idempotencyKey', input.idempotencyKey)
  formData.append('utrNumber', input.utrNumber)
  formData.append('transactionDocument', input.transactionDocument)
  const { data } = await investorApi.post<unknown>(FIAT_WALLET_ENDPOINTS.ADD_FUNDS, formData)
  return parseAddFunds(data)
}
